<template>
  <section class="login-screen">
    <img
      src="../assets/images/statics/slider.webp"
      alt=""
      class="login-bg-image"
    />

    <div class="login-overlay"></div>
    <div class="login-grid-glow login-grid-glow-left"></div>
    <div class="login-grid-glow login-grid-glow-right"></div>

    <div class="login-shell">
      <aside class="login-copy-panel">
        <div class="login-badge">ERP INTELIGENTE</div>

        <div class="login-copy-stack">
          <h1 class="login-title">
            Tu negocio,
            <span>más simple,</span>
            <span>más eficiente.</span>
          </h1>

          <p class="login-description">
            Todo lo que necesitas para gestionar ventas, inventario, clientes y más,
            con <strong>Facturación Electrónica</strong> integrada.
          </p>

          <div class="login-feature-list">
            <article class="login-feature-item">
              <div class="login-feature-icon">FE</div>
              <div>
                <h3>Facturación Electrónica</h3>
                <p>Cumple con DGII/SUNAT y envía tus e-CF automáticamente.</p>
              </div>
            </article>

            <article class="login-feature-item">
              <div class="login-feature-icon">VI</div>
              <div>
                <h3>Ventas e Inventario</h3>
                <p>Control total en tiempo real desde cualquier dispositivo.</p>
              </div>
            </article>

            <article class="login-feature-item">
              <div class="login-feature-icon">CC</div>
              <div>
                <h3>Clientes y CRM</h3>
                <p>Gestiona relaciones y brinda una mejor experiencia.</p>
              </div>
            </article>

            <article class="login-feature-item login-feature-item-last">
              <div class="login-feature-icon">SC</div>
              <div>
                <h3>Seguro y Confiable</h3>
                <p>Tus datos siempre protegidos con altos estándares.</p>
              </div>
            </article>
          </div>
        </div>

        <div class="login-stat-row">
          <div class="login-stat-card">
            <span>Rápido</span>
            <p>Automatiza procesos y reduce errores manuales.</p>
          </div>
          <div class="login-stat-card">
            <span>En la nube</span>
            <p>Accede a tu operación desde cualquier lugar.</p>
          </div>
          <div class="login-stat-card">
            <span>Escalable</span>
            <p>Crece con tu negocio sin cambiar de sistema.</p>
          </div>
        </div>
      </aside>

      <div class="login-center-stage">
        <div class="login-frame">
          <div class="login-card">
            <div class="login-company-header">
              <div v-if="loadingCompany" class="login-company-loading">
                <div class="login-company-logo-skeleton"></div>
                <div class="login-company-name-skeleton"></div>
              </div>

              <div v-else class="login-company-brand">
                <div class="login-company-logo-wrap">
                  <img :src="URL_RESOURCE + dataForm.logo" alt="Logo de la empresa" class="login-company-logo" />
                </div>
                <div>
                  <p class="login-company-caption">Acceso seguro</p>
                  <div class="login-company-name">{{ dataForm.name }}</div>
                </div>
              </div>
            </div>

            <div class="login-heading-block">
              <h2 class="login-heading">Inicio de sesión</h2>
              <p class="login-subheading">Ingresa con tu turno asignado para continuar en el sistema.</p>
            </div>

            <form class="login-form" @submit.prevent="login" @dragenter="false" autocomplete="false">
              <label class="login-field">
                <span class="login-label">Turnos</span>
                <div class="login-turns-field">
                  <Turns variant="dark" @send-data="getTurns" />
                </div>
              </label>

              <label class="login-field">
                <span class="login-label">Correo electrónico</span>
                <input
                  v-model="dataLogin.email"
                  type="email"
                  class="login-input"
                  placeholder="Correo electrónico..."
                  v-on:keyup.enter.prevent
                />
              </label>

              <label class="login-field">
                <span class="login-label">Contraseña</span>
                <input
                  v-model="dataLogin.password"
                  type="password"
                  class="login-input"
                  placeholder="Contraseña..."
                  v-on:keyup.enter.prevent
                />
              </label>

              <button class="login-submit" type="submit" :disabled="dataForm.stateLogin">
                <font-awesome-icon icon="fa-solid fa-right-to-bracket" class="small-hidden h-4 w-4" />
                <span v-if="!dataForm.stateLogin">Iniciar sesión</span>
                <span v-else>Ingresando</span>
              </button>
            </form>

            <div class="login-support-block">
              <p class="login-support-title">Contactos de soporte</p>

              <div class="login-support-links">
                <a
                  href="https://wa.link/sp2c3c"
                  target="_blank"
                  rel="noreferrer"
                  class="login-support-link login-support-link-whatsapp"
                  aria-label="WhatsApp"
                >
                  <svg class="h-4 w-4 icons whatsapp" style="fill:#ffffff;">
                    <use href="@/assets/svg/icon.svg#whatsapp" />
                  </svg>
                </a>
                <a
                  href="https://www.youtube.com/@jasoftware6111/featured"
                  target="_blank"
                  rel="noreferrer"
                  class="login-support-link login-support-link-youtube"
                  aria-label="YouTube"
                >
                  <svg class="h-4 w-4 icons youtube" style="fill:#ffffff;">
                    <use href="@/assets/svg/icon.svg#youtube" />
                  </svg>
                </a>
                <a
                  href="https://web.facebook.com/profile.php?id=100083456256377&_rdc=1&_rdr"
                  target="_blank"
                  rel="noreferrer"
                  class="login-support-link login-support-link-facebook"
                  aria-label="Facebook"
                >
                  <svg class="h-4 w-4 icons" style="fill:#ffffff;">
                    <use href="@/assets/svg/icon.svg#facebook" />
                  </svg>
                </a>
              </div>
            </div>

            <div class="login-slider-wrap">
              <Slider />
            </div>
          </div>
        </div>
      </div>

      <aside class="login-visual-panel">
        <div class="login-visual-card login-visual-card-top">
          <span>Dashboard</span>
          <strong>Ventas del mes</strong>
          <p>Seguimiento de ventas, órdenes y clientes en tiempo real.</p>
        </div>

        <div class="login-visual-card login-visual-card-bottom">
          <span>Movilidad</span>
          <strong>Opera donde estés</strong>
          <p>Acceso rápido desde escritorio, laptop y móvil con la misma experiencia.</p>
        </div>
      </aside>
    </div>
  </section>
</template>

<script>
import PWADetector from '@/utils/pwa/pwaDetector';
import Turns from "@/components/PublicComponents/Turns.vue";
import Slider from "@/components/Sliders/Login.vue";
import { onMounted, ref } from "vue";
import axios from "@/api";
import { errorActions, warningActions } from "@/alerts";
import { clearStoredSession } from "@/publicjs/authSession";
export default {
  name: "LoginApp",
  components: {
    Turns,
    Slider,
  },

  setup() {
    //datos de los selection option
    const dataForm = ref({
      idTurn: 0,
      name: null,
      logo: null,
      stateLogin: false,
    });

    //datos para iniciar sesión
    const dataLogin = ref({
      email: "",
      password: "",
    });

    //dominio de api para traer los recursos de la empresa
    const URL_RESOURCE = process.env.VUE_APP_API_URL_RESOURCE;

    //obtiene los datos de la empresa
    const loadingCompany = ref(true);
    const getCompany = async () => {
      const response = await axios.get(process.env.VUE_APP_API_URL + "empresa").catch((error) => {
        errorActions(error?.response?.data?.message || error.message || "No se pudo conectar con el backend para cargar la empresa.");
        return null;
      });

      if (!response?.data?.[0]) {
        loadingCompany.value = false;
        return;
      }

      const data = response.data[0];
      dataForm.value.name = data.razon_social;
      dataForm.value.logo = data.logo;
      loadingCompany.value = false;
    };
    onMounted(() => {
      getCompany();
    });

    const resetLoginState = () => {
      dataLogin.value.email = "";
      dataLogin.value.password = "";
      dataForm.value.stateLogin = false;
    };

    const login = async () => {
      try {
        if (dataForm.value.idTurn === 0 || dataForm.value.idTurn === null) {
          errorActions("Selecciona el turno, para acceder al sistema");
          return;
        }

        if (dataLogin.value.password <= 2) {
          warningActions(
            "Por favor ingresa un contraseña para poder iniciar sesión"
          );
          return;
        }

        clearStoredSession();
        localStorage.removeItem("boxState");
        dataForm.value.stateLogin = true;
        const response = await axios.post(
          process.env.VUE_APP_API_URL + "login",
          {
            correo: dataLogin.value.email,
            password: dataLogin.value.password,
            turn: dataForm.value.idTurn,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        const data = await response.data;
        const schedules = Array.isArray(data?.user?.schedules)
          ? data.user.schedules
          : [];
        const selectedTurnId = Number(dataForm.value.idTurn);
        const currentSchedule =
          schedules.find((schedule) => Number(schedule.turn) === selectedTurnId) ??
          null;

        if (!currentSchedule || currentSchedule.hasAccessToday === false) {
          errorActions(
            "Lo sentimos, Ud. no tiene el acceso configurado para el día de hoy"
          );
          resetLoginState();
          return;
        }

        if (currentSchedule.isInTime === false) {
          errorActions(
            "No puedes acceder al sistema porque en este momento estás fuera de tu horario laboral configurado. Si entiendes que deberías tener acceso ahora, contacta al administrador para que revise tu horario."
          );
          resetLoginState();
          return;
        }

        if (currentSchedule.isInTime && currentSchedule.hasAccessToday) {
          const accessPayload = {
            ...data,
            user: {
              ...data.user,
              currentTurn: selectedTurnId,
            },
          };

          localStorage.setItem("access", JSON.stringify(accessPayload));

          // Resetear cooldowns de PWA para mostrar banner en nuevo login
          PWADetector.resetBannerCooldowns();

          // Marcar que debe mostrar PWA después de redirigir
          localStorage.setItem('pwa-show-after-login', 'true');

          if (localStorage.getItem("access")) {
            /*************************************************************
             * Validamos si la caja del usuario se encuentra abierta
             *************************************************************/
            const responseBox = await axios
              .get(
                `caja/check-status/?idstore=${data.user.store}&iduser=${data.user.key}&idturn=${selectedTurnId}`
              )
              .catch((error) => {
                errorActions(error);
                return null;
              });
            const dataBox = responseBox?.data;
            if (dataBox?.msg === "caja abierta") {
              localStorage.setItem("boxState", true);
            } else {
              localStorage.removeItem("boxState");
            }
            /*************************************************************
             * Redireccionamos al inicio del sistema
             *************************************************************/

            resetLoginState();
            window.location.href = "/";
          }
        }
      } catch (error) {
        if (error?.response?.status === 401) {
          errorActions(error.response.data.error);
        } else {
          errorActions(error?.response?.data?.message || error.message || "No se pudo conectar con el backend.");
        }
        clearStoredSession();
        localStorage.removeItem("boxState");
        dataForm.value.stateLogin = false;
      }
    };

    //recepcion de datos desde el componente publico, todos los tipos de usuarios
    const getTurns = (data) => {
      dataForm.value.idTurn = data;
    };
    return {
      URL_RESOURCE,
      loadingCompany,
      getTurns,
      dataLogin,
      dataForm,
      login,
    };
  },
};
</script>

<style scoped>
.login-screen {
  position: relative;
  min-height: var(--app-height);
  width: 100%;
  overflow: hidden;
  background:
    radial-gradient(circle at top left, rgba(31, 118, 255, 0.28), transparent 30%),
    linear-gradient(135deg, #020b2e 0%, #04164f 48%, #03133c 100%);
}

.login-bg-image {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: 0.72;
}

.login-overlay {
  position: absolute;
  inset: 0;
  background:
    linear-gradient(90deg, rgba(2, 9, 35, 0.96) 0%, rgba(4, 18, 66, 0.75) 38%, rgba(4, 20, 67, 0.42) 68%, rgba(2, 11, 36, 0.9) 100%),
    radial-gradient(circle at center, rgba(53, 139, 255, 0.18), transparent 38%);
}

.login-grid-glow {
  position: absolute;
  border-radius: 9999px;
  filter: blur(70px);
  opacity: 0.6;
}

.login-grid-glow-left {
  left: -10rem;
  top: 10%;
  width: 18rem;
  height: 18rem;
  background: rgba(45, 126, 255, 0.18);
}

.login-grid-glow-right {
  right: -8rem;
  bottom: 12%;
  width: 16rem;
  height: 16rem;
  background: rgba(1, 200, 255, 0.16);
}

.login-shell {
  position: relative;
  z-index: 1;
  display: grid;
  min-height: var(--app-height);
  width: 100%;
  grid-template-columns: minmax(0, 1fr);
  gap: 2rem;
  padding: 1.25rem;
}

.login-copy-panel,
.login-center-stage,
.login-visual-panel {
  position: relative;
}

.login-copy-panel {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 1.5rem;
  width: 100%;
  color: #fff;
}

.login-badge {
  display: inline-flex;
  width: fit-content;
  border: 1px solid rgba(72, 146, 255, 0.45);
  border-radius: 9999px;
  padding: 0.55rem 1rem;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.16em;
  color: #d7e7ff;
  background: rgba(8, 24, 73, 0.48);
  box-shadow: inset 0 0 0 1px rgba(133, 180, 255, 0.08);
}

.login-copy-stack {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.login-title {
  max-width: 32rem;
  font-size: clamp(2.6rem, 7vw, 5rem);
  font-weight: 800;
  line-height: 0.98;
  letter-spacing: -0.04em;
}

.login-title span {
  display: block;
  color: #338cff;
}

.login-description {
  max-width: 31rem;
  color: rgba(217, 229, 255, 0.88);
  font-size: 1.05rem;
  line-height: 1.7;
}

.login-description strong {
  color: #2ba7ff;
}

.login-feature-list {
  display: grid;
  max-width: 33rem;
  border-top: 1px solid rgba(120, 166, 255, 0.15);
}

.login-feature-item {
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 1rem;
  align-items: start;
  padding: 1.2rem 0;
  border-bottom: 1px solid rgba(120, 166, 255, 0.12);
}

.login-feature-item-last {
  border-bottom: 0;
}

.login-feature-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 3.25rem;
  height: 3.25rem;
  border-radius: 9999px;
  border: 1px solid rgba(90, 158, 255, 0.4);
  background: linear-gradient(180deg, rgba(22, 85, 194, 0.35), rgba(7, 24, 78, 0.5));
  color: #73b5ff;
  font-size: 0.85rem;
  font-weight: 800;
  box-shadow: 0 0 30px rgba(34, 120, 255, 0.18);
}

.login-feature-item h3 {
  margin: 0;
  color: #ffffff;
  font-size: 1.03rem;
  font-weight: 700;
}

.login-feature-item p {
  margin: 0.35rem 0 0;
  color: rgba(207, 221, 255, 0.74);
  font-size: 0.95rem;
  line-height: 1.5;
}

.login-stat-row {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 1rem;
}

.login-stat-card {
  min-height: 6.5rem;
  border: 1px solid rgba(91, 151, 255, 0.16);
  border-radius: 1.25rem;
  padding: 1rem 1.1rem;
  background: rgba(6, 18, 58, 0.48);
  backdrop-filter: blur(14px);
}

.login-stat-card span {
  display: block;
  margin-bottom: 0.55rem;
  color: #ffffff;
  font-size: 1.02rem;
  font-weight: 700;
}

.login-stat-card p {
  margin: 0;
  color: rgba(207, 221, 255, 0.72);
  font-size: 0.88rem;
  line-height: 1.45;
}

.login-center-stage {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.login-frame {
  width: 100%;
  max-width: 30.5rem;
  border: 1px solid rgba(78, 141, 255, 0.45);
  border-radius: 2rem;
  padding: 0.85rem;
  background: linear-gradient(180deg, rgba(18, 42, 112, 0.16), rgba(3, 14, 48, 0.08));
  box-shadow:
    0 0 0 1px rgba(70, 145, 255, 0.12),
    0 0 35px rgba(52, 127, 255, 0.38),
    inset 0 0 35px rgba(91, 164, 255, 0.08);
  backdrop-filter: blur(12px);
}

.login-card {
  border-radius: 1.5rem;
  padding: 1.3rem;
  background: linear-gradient(180deg, rgba(11, 43, 73, 0.96) 0%, rgba(11, 53, 84, 0.9) 100%);
  box-shadow: inset 0 0 0 1px rgba(114, 187, 255, 0.08);
}

.login-company-header {
  margin-bottom: 1.35rem;
}

.login-company-loading,
.login-company-brand {
  display: flex;
  align-items: center;
  gap: 0.85rem;
}

.login-company-logo-skeleton,
.login-company-name-skeleton {
  border-radius: 0.9rem;
  background: rgba(177, 212, 255, 0.18);
  animation: pulse 1.8s ease-in-out infinite;
}

.login-company-logo-skeleton {
  width: 3rem;
  height: 3rem;
}

.login-company-name-skeleton {
  width: 8rem;
  height: 1.3rem;
}

.login-company-logo-wrap {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 3.25rem;
  height: 3.25rem;
  border-radius: 1rem;
  background: rgba(111, 184, 255, 0.08);
  border: 1px solid rgba(134, 193, 255, 0.18);
}

.login-company-logo {
  width: 2.25rem;
  height: 2.25rem;
  object-fit: contain;
}

.login-company-caption {
  margin: 0 0 0.15rem;
  color: #86c4ff;
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.login-company-name {
  color: #ffffff;
  font-size: 1.05rem;
  font-weight: 700;
}

.login-heading-block {
  margin-bottom: 1.15rem;
}

.login-heading {
  margin: 0;
  color: #eff7ff;
  font-size: 2rem;
  font-weight: 700;
}

.login-subheading {
  margin: 0.45rem 0 0;
  color: rgba(214, 229, 255, 0.72);
  font-size: 0.95rem;
  line-height: 1.5;
}

.login-form {
  display: grid;
  gap: 0.85rem;
}

.login-field {
  display: block;
}

.login-label {
  display: block;
  margin-bottom: 0.55rem;
  color: #f3f8ff;
  font-size: 0.92rem;
  font-weight: 600;
}

.login-input,
.login-turns-field :deep(select),
.login-turns-field :deep(div[v-show="loading"]) {
  width: 100%;
  min-height: 3.05rem;
  border: 1px solid rgba(115, 180, 255, 0.18);
  border-radius: 0.95rem;
  background: rgba(9, 54, 86, 0.92);
  color: #eff7ff;
  font-size: 0.95rem;
  outline: none;
  box-shadow: inset 0 0 0 1px rgba(144, 201, 255, 0.03);
  transition: border-color 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;
}

.login-input {
  padding: 0.82rem 1rem;
}

.login-turns-field :deep(select),
.login-turns-field :deep(div[v-show="loading"]) {
  margin-bottom: 0;
  padding: 0.82rem 1rem;
  text-transform: none;
}

.login-turns-field :deep(option) {
  color: #0d2344;
}

.login-input::placeholder {
  color: rgba(185, 212, 255, 0.5);
}

.login-input:focus,
.login-turns-field :deep(select:focus) {
  border-color: rgba(75, 156, 255, 0.88);
  box-shadow: 0 0 0 4px rgba(48, 124, 255, 0.18);
  background: rgba(8, 57, 89, 1);
}

.login-submit {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.65rem;
  min-height: 3.05rem;
  width: 100%;
  border: 0;
  border-radius: 0.95rem;
  background: linear-gradient(180deg, #4f97ff 0%, #2f78f6 100%);
  color: #ffffff;
  font-size: 0.98rem;
  font-weight: 700;
  box-shadow: 0 16px 32px rgba(52, 122, 255, 0.34);
  transition: transform 0.2s ease, box-shadow 0.2s ease, opacity 0.2s ease;
}

.login-submit:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 18px 38px rgba(52, 122, 255, 0.4);
}

.login-submit:disabled {
  cursor: not-allowed;
  opacity: 0.75;
}

.login-support-block {
  margin-top: 1.1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.75rem;
}

.login-support-title {
  margin: 0;
  color: #94c7ff;
  font-size: 0.92rem;
  font-weight: 600;
  animation: supportTitleGlow 2.8s ease-in-out infinite;
}

.login-support-links {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.7rem;
}

.login-support-link {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.45rem;
  height: 2.45rem;
  border-radius: 9999px;
  border: 1px solid rgba(118, 187, 255, 0.12);
  background: rgba(11, 63, 99, 0.9);
  transition: transform 0.2s ease, background 0.2s ease, border-color 0.2s ease;
  animation: socialFloat 3.4s ease-in-out infinite;
  box-shadow: 0 0 0 rgba(97, 171, 255, 0.2);
}

.login-support-link:hover {
  transform: translateY(-4px) scale(1.06);
  border-color: rgba(118, 187, 255, 0.3);
  background: rgba(12, 77, 119, 0.96);
}

.login-support-link-whatsapp {
  animation-delay: 0s;
}

.login-support-link-youtube {
  animation-delay: 0.35s;
}

.login-support-link-facebook {
  animation-delay: 0.7s;
}

.login-slider-wrap {
  margin-top: 1rem;
}

.login-visual-panel {
  display: none;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.login-visual-card {
  max-width: 15rem;
  border: 1px solid rgba(110, 178, 255, 0.18);
  border-radius: 1.5rem;
  padding: 1.2rem;
  background: rgba(6, 20, 61, 0.54);
  color: #ffffff;
  backdrop-filter: blur(10px);
  box-shadow: 0 18px 45px rgba(3, 9, 32, 0.24);
}

.login-visual-card span {
  display: block;
  color: #72b2ff;
  font-size: 0.76rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.login-visual-card strong {
  display: block;
  margin-top: 0.45rem;
  font-size: 1.15rem;
  line-height: 1.2;
}

.login-visual-card p {
  margin: 0.55rem 0 0;
  color: rgba(212, 228, 255, 0.78);
  font-size: 0.92rem;
  line-height: 1.55;
}

.login-visual-card-top {
  margin-top: -8rem;
}

.login-visual-card-bottom {
  margin-top: 18rem;
  margin-left: -2rem;
}

.icons:hover {
  fill: rgb(3, 102, 194) !important;
}

.icons.whatsapp:hover {
  fill: rgb(26, 179, 115) !important;
}

.icons.youtube:hover {
  fill: rgb(255, 121, 121) !important;
}

@keyframes pulse {
  0%,
  100% {
    opacity: 0.5;
  }
  50% {
    opacity: 1;
  }
}

@keyframes socialFloat {
  0%,
  100% {
    transform: translateY(0) scale(1);
    box-shadow: 0 0 0 rgba(97, 171, 255, 0.12);
  }
  50% {
    transform: translateY(-4px) scale(1.04);
    box-shadow: 0 10px 22px rgba(97, 171, 255, 0.18);
  }
}

@keyframes supportTitleGlow {
  0%,
  100% {
    opacity: 0.75;
    transform: translateY(0);
    text-shadow: 0 0 0 rgba(132, 201, 255, 0);
  }
  50% {
    opacity: 1;
    transform: translateY(-2px);
    text-shadow: 0 0 14px rgba(132, 201, 255, 0.38);
  }
}

@media (max-width: 1023px) {
  .login-copy-panel {
    order: 2;
  }

  .login-center-stage {
    order: 1;
  }

  .login-copy-stack {
    align-items: center;
    text-align: center;
  }

  .login-feature-list {
    max-width: 100%;
  }
}

@media (max-width: 767px) {
  .login-shell {
    gap: 1.25rem;
    padding: 0.9rem;
  }

  .login-copy-panel {
    gap: 1.25rem;
  }

  .login-title {
    font-size: clamp(2.2rem, 10vw, 3.4rem);
  }

  .login-description {
    font-size: 0.95rem;
  }

  .login-feature-list,
  .login-stat-row {
    display: none;
  }

  .login-frame {
    max-width: none;
    border-radius: 1.6rem;
    padding: 0.7rem;
  }

  .login-card {
    padding: 1.2rem;
    border-radius: 1.2rem;
  }

  .login-heading {
    font-size: 1.7rem;
  }

  .login-support-block {
    margin-top: 1.1rem;
  }
}

@media (min-width: 768px) {
  .login-shell {
    align-items: center;
    padding: 1.5rem;
  }
}

@media (min-width: 1024px) {
  .login-shell {
    grid-template-columns: minmax(0, 1fr) minmax(340px, 430px) minmax(0, 1fr);
    align-items: center;
    padding: 1.75rem 1.5rem;
  }

  .login-copy-panel {
    padding: 1rem 1rem 1rem 0;
    justify-self: stretch;
  }

  .login-visual-panel {
    display: flex;
    justify-self: end;
  }
}

@media (min-width: 1440px) {
  .login-shell {
    padding: 2rem 3rem;
  }
}
</style>